import React from 'react';
import BaseInput from './BaseInput';

export default function RawDisplayValue({
  label,
  useFieldStyling = false,
  value,
  scrollY,
}: {
  label: string;
  useFieldStyling?: boolean;
  value: unknown;
  scrollY?: boolean;
}): React.JSX.Element {
  if (typeof value === 'boolean') {
    value = value ? 'true' : 'false';
  }
  return (
    <BaseInput
      label={label}
      border={useFieldStyling ? '1px solid #CBD5E1' : undefined}
      backgroundColor={useFieldStyling ? '#efefef' : undefined}
      labelClassName='vgs-show-label'
      scrollY={scrollY}
    >
      <div className='vgs-ref font-medium vgs-show'>{`${value}`}</div>
    </BaseInput>
  );
}
